import { Box, styled } from '@mui/material';

export const HeaderCellBody = styled(Box)(() => ({
  height: '100%',
  width: '14%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
}));
